import React, { useContext, useState } from 'react';
import { Modal, Col, Row, Form, Button, Spinner, Card } from 'react-bootstrap';
import { AuthContext } from '../../../auth/AuthContext';
import { useContextInfo } from '../../../context/ContextInfo';
import { fetchConToken } from '../../../api/fetch';
const ModCancelFac = ({ show, onClose, callBk, data }) => {
    const { auth } = useContext(AuthContext);
    const { setResp } = useContextInfo();
    const [load, setLoad] = useState(false);
    const [motive, setMotivo] = useState('01');
    const onSubmit = async (e) => {
        e.preventDefault();

        if (load) return;
        setLoad(true);
        let res = await fetchConToken(
            `factura/cancel`,
            {
                motive,
                id: data.id,
                fcId: data.fcId,
                email: data.correo,
                id_user: data.idcliente,
                agente: auth.uid,
            },
            'PUT'
        );
        setResp(res);
        setLoad(false);
        if (res.ok) {
            callBk();
            onClose();
        }
    };
    return (
        <Modal show={show} onHide={onClose}>
            <Modal.Header onHide={onClose} closeButton>
                <h4 className="modal-title">Cancelar factura</h4>
            </Modal.Header>
            <Modal.Body>
                <>
                    <Row>
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Form noValidate onSubmit={onSubmit}>
                                        <p>
                                            Cancelar factura con numero de folio <b>{data.folio}</b>{' '}
                                        </p>
                                        <Col>
                                            {' '}
                                            <Form.Group className="mb-3" controlId="validationCustom0">
                                                <Form.Label>Ubicación</Form.Label>
                                                <Form.Select
                                                    value={motive}
                                                    name="tipo"
                                                    required
                                                    onChange={(e) => setMotivo(e.target.value)}>
                                                    <option value="01">
                                                        Comprobante emitido con errores con relación
                                                    </option>
                                                    <option value="02">
                                                        Comprobante emitido con errores sin relación.
                                                    </option>
                                                    <option value="03">No se llevó a cabo la operación.</option>
                                                    <option value="04">
                                                        Operación nominativa relacionada en la factura global.
                                                    </option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>{' '}
                                        {load ? (
                                            <Button color="primary" disabled>
                                                <Spinner className="spinner-border-sm me-1" tag="span" color="white" />
                                                Guardando...
                                            </Button>
                                        ) : (
                                            <Button type="submit">Cancelar factura</Button>
                                        )}
                                    </Form>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                </>
            </Modal.Body>
        </Modal>
    );
};

export default ModCancelFac;
